import { RegistrationPage } from "fleet/view/user/register";
import get from "lodash/get";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { REGISTER_USER, USER_INVITE_DETAILS } from "redux-store/users/actions";

function mapStateToProps(state, props) {
  const inviteId = get(props, "match.params.id", null);

  return {
    inviteId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    inviteDetails: (inviteId) => {
      return createPromiseApiAction(dispatch, USER_INVITE_DETAILS, [inviteId]);
    },
    register: (inviteId, name, p1, p2) => {
      return createPromiseApiAction(dispatch, REGISTER_USER, [
        inviteId,
        name,
        p1,
        p2,
      ]);
    },
  };
}

const ConnectedUserRegister = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RegistrationPage);

export { ConnectedUserRegister };
